import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AdminLayout } from '../components/layout';
import { PageState } from '../components/common';
import {
  StatisticsCards,
  RecentOrdersList,
  DashboardHeader,
} from '../components/admin/DashboardComponents';
import { useAdminDashboard } from '../hooks';
import { formatDate } from '../utils/commonUtils';

const AdminPanel: React.FC = () => {
  const navigate = useNavigate();
  const { stats, recentOrders, loading, error, refreshData, getStatusText, getStatusColor } =
    useAdminDashboard();

  const handleOrderClick = (orderId: number) => {
    navigate(`/admin/orders/${orderId}`);
  };

  const handleViewAllOrders = () => {
    navigate('/admin/orders');
  };

  return (
    <AdminLayout title="Dashboard">
      <PageState
        loading={loading}
        error={error || undefined}
        loadingStateProps={{
          size: 'lg',
          text: 'Dashboard yükleniyor...',
          variant: 'admin',
        }}
        errorStateProps={{
          title: 'Dashboard Yükleme Hatası',
          variant: 'admin',
          onRetry: refreshData,
          retryText: 'Yeniden Yükle',
        }}
      >
        {/* Dashboard Header */}
        <DashboardHeader
          totalOrders={stats?.totalOrders || 0}
          lastUpdateTime={formatDate(new Date(), 'datetime')}
        />

        {/* Statistics Cards */}
        <StatisticsCards stats={stats} />

        {/* Recent Orders */}
        <RecentOrdersList
          orders={recentOrders}
          onOrderClick={handleOrderClick}
          onViewAll={handleViewAllOrders}
          getStatusText={getStatusText}
          getStatusColor={getStatusColor}
        />
      </PageState>
    </AdminLayout>
  );
};

export default AdminPanel;
